import Image from 'next/image';
import Breadcrumbs from "@/components/ui/Breadcrumbs";
import { useRouter } from 'next/router';


const AboutHero = ({ image, title, text, imageSmall }) => {

  const router = useRouter()
  const { locale } = router 

  
  return (
    <section className="flex container-max flex-col lg:flex-col-reverse w-full">
      <div className='w-full  container-padding'>
        <div className="w-full py-[2.4rem] mb-[1.6rem] md:mb-[2rem] md:py-[2rem] lg:pt-[2.4rem] lg:pb-[4rem] lg:mb-0 xl:pt-[4.8rem] xl:pb-[5.2rem]">
          <Breadcrumbs
            items={locale === 'ru' ? [
              { label: "ГЛАВНАЯ", href: "/" },
              { label: "О НАС", href: "/about" },
            ] : [{ label: "HOME", href: "/" },
              { label: "ABOUT US", href: "/about" },]}
            separator="/"
            itemClassName="text-base tracking-wide"
            linkClassName="text-[#bda76a]"
            currentClassName="text-[#0f1626]"
            separatorClassName="text-[#bda76a]"
          />
        </div>

        <div className="mb-[2.4rem] md:mb-[4rem] lg:mb-0 w-full">
          <h1 className="heading-2 mb-[1.6rem] lg:mb-[2.8rem] xl:mb-[3.6rem] text-dark-blue">{title}</h1>
          <div className='container-grid'>
              <p className="text-1 md:col-span-4 md:max-w-[46rem] lg:max-w-[50rem] xl:max-w-[60rem] lg:col-span-4 xl:col-span-4 text-dark-blue">{text.normalize('NFC')}</p>
          </div>
          
        </div>
      </div>

      <div className="w-full relative h-[25rem] md:h-[32rem] lg:md:h-auto lg:aspect-[1/0.32]">
        <Image
          src={image.url}
          alt={image.alt}
          fill
          priority={true}
          quality={90}
          sizes="100vw" 
          fetchPriority="high"
          className="w-auto hidden md:block object-cover"
        />

        <Image
          src={imageSmall.url}
          alt={imageSmall.alt}
          fill
          priority={true}
          sizes="100vw" 
          fetchPriority="high"
          className="w-auto md:hidden object-cover"
        />
      </div>
    </section>
  );
};

export default AboutHero;